<template>
  <div @click="handleMainAreaClick" class="main-area">
    <div id="map"></div>
    <SearchMarker v-if="markerInfo" :map="map" :marker-info="markerInfo"></SearchMarker>
    <div v-if="showRectangle"
         class="mid-center"
         style="position: absolute;background: rgba(71, 157, 255, 0.2);pointer-events: none;"
         :data-rectangle="true"
         :style="{
           width: `${squareWidthPixel}px`,
           height: `${squareHeightPixel}px`,
           left: `calc(50% - ${squareWidthPixel / 2}px)`,
           top: `calc(50% - ${squareHeightPixel / 2}px)`,
           border: `2px ${isConfirmed ? 'solid' : 'dashed'} dodgerblue`,
         }">
      <div v-if="!isConfirmed" style="color: white;font-family:YouSheBiaoTiHei;font-size: 18px;">
        点击确认范围
      </div>
      <div v-else style="color: white;font-family:YouSheBiaoTiHei;font-size: 18px;display: flex; flex-direction: column; align-items: center;">
        <div>支付成功后1-2个工作日</div>
        <div>
          <span>可在</span>
          <span style="margin-left: 4px;margin-right: 4px;color: rgba(255, 195, 0, 1)">个人中心-我的数据</span>
          <span>查看下载</span>
        </div>
      </div>
    </div>
    <div @click="changeRoadVisibility"
         :style="{color: roadVisible ? 'rgba(71, 157, 255, 1)' : 'white'}"
         style="position: absolute;right: 23px;top: 105px;color: white;font-size: 18px">
      <div class="iconfontFamily">&#xe835;</div>
    </div>
    <div @click="resetBearing"
        :style="compassStyle"
        style="position: absolute;right: 18px;bottom: 275px;color: white;font-size: 18px">
      <div class="iconfontFamily">&#xe7ec;</div>
    </div>
    <div @click="getLocation" style="position: absolute;right: 18px;bottom: 230px;color: white;font-size: 18px">
      <div class="iconfontFamily">&#xe65b;</div>
    </div>
  </div>
</template>

<script>
import mapboxgl from "mapbox-gl";
import {getMapboxToken} from "@/utils/utils";
import SearchMarker from "@/views/OrbitSatellite/ActivityPage/SatelliteActivityBugJpg/SearchMarker.vue";

export default {
  name: 'CustomJpgOrder',
  components: {SearchMarker},
  data() {
    return {
      map: '',
      showRectangle: false,
      rectangleWidth: 1,
      rectangleHeight: 1,
      squareWidthPixel: 0,
      squareHeightPixel: 0,
      isConfirmed: false,
      markerInfo: '',
      bearing: 0,
      roadVisible: false,
    }
  },
  computed: {
    compassStyle() {
      return {
        transform: `rotate(${this.bearing * -1}deg)`,
        transformOrigin: 'center',
        transition: 'transform 0.0s ease',  // 平滑过渡
      }
    }
  },
  methods: {
    async initMapbox() {
      await getMapboxToken()
      mapboxgl.accessToken = this.globalJS.mapboxToken
      this.map = new mapboxgl.Map({
        container: 'map',
        center: [102.55, 40.32],
        zoom: 2,
        style: this.globalJS.mapboxStyle,
        minPitch: 0,
        maxPitch: 0,
        maxZoom: 14,
        minZoom: 1,
        transformRequest: (url) => {
          if (url.indexOf('https://api.mapbox.com') > -1) {
            return {
              url: url.replace('https://api.mapbox.com', 'https://earth.jl1.cn/mapbox'),
            };
          }
        }
      })
      this.map.on('load', () => {
        this.map.addSource("world2021", {
          type: 'raster',
          tiles: [
            this.globalJS.world1mUrl_2021
          ],
          tileSize: 256,
          scheme: 'tms',
        })
        this.map.addLayer({
          id: "world2021",
          type: 'raster',
          source: "world2021",
        })
        this.map.on('rotate', () => {
          this.bearing = this.map.getBearing();
        });
      })
    },
    showConfirmArea() {
      this.showRectangle = true
    },
    hideConfirmArea() {
      this.showRectangle = false
      this.isConfirmed = false
      this.enableMapInteract()
    },
    changeAreaSize(width, height) {
      this.rectangleWidth = width
      this.rectangleHeight = height
      let mapDom = document.getElementById('map')
      let mapRatio = mapDom.clientWidth / mapDom.clientHeight
      let ratio = width / height
      if (mapRatio > ratio) {
        this.squareHeightPixel = mapDom.clientHeight * 0.75
        this.squareWidthPixel = this.squareHeightPixel * ratio
      } else {
        this.squareWidthPixel = mapDom.clientWidth * 0.75
        this.squareHeightPixel = this.squareWidthPixel / ratio
      }
    },
    handleMainAreaClick(event) {
      if (this.isConfirmed || !this.showRectangle) {
        return
      }
      // 检查点击是否在矩形区域内
      let mapDom = document.getElementById('map')
      let mapWidth = mapDom.clientWidth
      let mapHeight = mapDom.clientHeight
      let x = event.x, y = event.y
      if (x < (mapWidth - this.squareWidthPixel) / 2 || y < (mapHeight - this.squareHeightPixel) / 2 ||
          x > (mapWidth + this.squareWidthPixel) / 2 || y > (mapHeight + this.squareHeightPixel) / 2) {
        console.log('不在范围')
        return
      }
      this.clickConfirmArea()
    },
    normalizeLngLat(lngLat) {
      let lng = lngLat.lng
      let lat = lngLat.lat

      // 标准化经度到 [-180, 180]
      lng = ((lng + 180) % 360) - 180
      if (lng < -180) lng += 360
      if (lng > 180) lng -= 360

      // 限制纬度到 [-85, 85]（实际地理极限）
      lat = Math.max(-85, Math.min(85, lat))

      return { lng, lat }
    },
    clickConfirmArea() {
      // 获取当前四角点坐标
      const mapDom = document.getElementById('map')
      const mapHeight = mapDom.clientHeight
      const mapWidth = mapDom.clientWidth
      const leftTopCoord = [
        mapWidth * 0.5 - this.squareWidthPixel / 2,
        mapHeight * 0.5 - this.squareHeightPixel / 2,
      ]
      const leftBottomCoord = [
        mapWidth * 0.5 - this.squareWidthPixel / 2,
        mapHeight * 0.5 + this.squareHeightPixel / 2,
      ]
      const rightBottomCoord = [
        mapWidth * 0.5 + this.squareWidthPixel / 2,
        mapHeight * 0.5 + this.squareHeightPixel / 2,
      ]
      const rightTopCoord = [
        mapWidth * 0.5 + this.squareWidthPixel / 2,
        mapHeight * 0.5 - this.squareHeightPixel / 2,
      ]
      const leftTopLngLat = this.normalizeLngLat(this.map.unproject(leftTopCoord))
      const leftBottomLngLat = this.normalizeLngLat(this.map.unproject(leftBottomCoord))
      const bottomRightLngLat = this.normalizeLngLat(this.map.unproject(rightBottomCoord))
      const rightTopLngLat = this.normalizeLngLat(this.map.unproject(rightTopCoord))
      // const centerLngLat = this.normalizeLngLat(this.map.unproject([mapWidth * 0.5, mapHeight * 0.5]))
      const coordinates = [
        leftTopLngLat,      // 左上
        rightTopLngLat,     // 右上
        bottomRightLngLat,  // 右下
        leftBottomLngLat,   // 左下
      ]
      const rotation = this.map.getBearing();
      if (window['flutter_clickConfirmArea']) {
        // 修改为发送一个包含所有参数的对象
        window['flutter_clickConfirmArea'].postMessage(JSON.stringify({
          coordinates: coordinates,  // 坐标数据
          rotation: rotation         // 旋转角度
        }));
      }
    },
    confirmArea() {
      this.isConfirmed = true
      this.disableMapInteract()
    },
    disableMapInteract() {
      this.map.dragPan.disable();
      this.map.dragRotate.disable();
      this.map.scrollZoom.disable();
      this.map.touchZoomRotate.disable();
      this.map.doubleClickZoom.disable();
      this.map.keyboard.disable();
      this.map.boxZoom.disable();
      this.map.touchPitch.disable();
    },
    enableMapInteract() {
      this.map.dragPan.enable();
      this.map.dragRotate.enable();
      this.map.scrollZoom.enable();
      this.map.touchZoomRotate.enable();
      this.map.doubleClickZoom.enable();
      this.map.keyboard.enable();
      this.map.boxZoom.enable();
      this.map.touchPitch.enable();
    },
    resetChooseArea() {
      this.isConfirmed = false
      this.enableMapInteract()
    },
    flyToPosition(lng, lat) {
      this.map.flyTo({
        center: [lng, lat],
        zoom: 14
      })
    },
    addMarker(lng, lat, name) {
      this.markerInfo = {
        lng: lng,
        lat: lat,
        name: name
      }
    },
    removeMarker() {
      this.markerInfo = ''
    },
    resetBearing() {
      if (this.isConfirmed) {
        return
      }
      this.map.setBearing(0)
    },
    getLocation() {
      if (this.isConfirmed) {
        return
      }
      if (window['flutter_customJpgOrderGetLocation']) {
        window['flutter_customJpgOrderGetLocation'].postMessage('')
      }
    },
    changeRoadVisibility() {
      if (this.isConfirmed) {
        return
      }
      this.roadVisible = !this.roadVisible
      if (this.roadVisible) {
        if (!this.map.getLayer('roadInfo')) {
          this.map.addSource('roadInfo', {
            type: 'raster',
            tiles: [
              'https://t0.tianditu.gov.cn/DataServer?T=cva_w&X={x}&Y={y}&L={z}&tk=f5e247a85a4e7b9a605370d0f769d080'
            ],
            tileSize: 256,
            maxzoom: 17,
          });
          this.map.addLayer({
            id: 'roadInfo',
            type: 'raster',
            source: 'roadInfo',
            // minzoom: 9,
          });
        }
        this.map.setLayoutProperty('roadInfo','visibility','visible')
      } else {
        this.map.setLayoutProperty('roadInfo','visibility','none')
      }
    }
  },
  mounted() {
    window.customJpgOrder = this
    this.initMapbox()
    this.changeAreaSize(1, 1)
  }
}
</script>

<style scoped>
.main-area {
  height: 100%;
  width: 100%;
  //background-color: black;
  //display: flex;
  //align-items: center;
  //position: absolute;
  //background-repeat: no-repeat;
  //background-position: center;
  //background-size: cover;
}

#map {
  position: absolute;
  top: 0;
  bottom: 0;
  width: 100%;
  height: 100%;
  overflow: hidden;
  //pointer-events: none;
}

.mid-center {
  display: flex;
  align-items: center;
  justify-content: center;
}

.rectangle-area {
  /* 允许所有触摸事件穿透到底层地图 */
  touch-action: none;
  /* 但允许点击事件 */
  pointer-events: auto;
}
</style>